module.exports = __webpack_public_path__ + "static/media/shape_H.716b33fe.glb";